import { combineReducers } from "redux";
import genesis from "./auth/genesis";
import login from "./auth/login"
import forgotPassword from "./auth/forgotPassword";
import forgotPasswordVerify from "./auth/forgotPasswordVerify";
import verifyCode from "./auth/verifyCode";
import register from "./auth/register";
import patientRegister from "./auth/patientRegister";
import professions from "./professions";
import setSurvey from "./application/setSurvey";
import startApplication from "./application/startApplication"
import careProviders from "./application/careProviders"
import assignApplication from "./application/assignApplication"
import payment from "./application/payment"
import getApplications from './application/getApplications'
import getApplication from './application/getApplication'
import getDoctorCv from "./application/getDoctorCv";
import addAddress from "./payment/addAddress";
import addBasket from "./payment/addBasket";
import checkout from "./payment/checkout";
import deleteBasket from "./payment/deleteBasket";
import getAddresses from "./payment/getAddresses";
import getBasket from "./payment/getBasket";
import getCitiesByDistrictName from "./payment/getCitiesByDistrictName";
import getCountries from "./payment/getCountries";
import removeAddress from "./payment/removeAddress";
import updateApplicationStatus from "./application/updateApplicationStatus";
import trigerApplicationStatus from "./application/trigerApplicationStatus";
import getOtp from "./agreement/getOtp"
import approveOtp from "./agreement/approveOtp";
import getMSS from "./agreement/getMSS";
import signMSS from "./agreement/signMSS";
import deleteAttachment from "./attachment/deleteAttachment";
import professionsv2 from "./v3/professions";
import careProvidersv2 from "./v3/careProviders";
import startApplicationv2 from "./v3/startApplication";
import attachFile from "./v3/attachFile";
import dettachFile from "./v3/dettachFile";
import pagingApplication from "./v3/pagingApplication";
import pagingApplicationsCareProvider from "./v3/pagingApplicationsCareProvider";
import addNote from "./v3/addNote";
import notifyPayment from "./v3/notifyPayment";
import applicationDetail from "./v3/applicationDetail"
import assessApplication from './v3/assessApplication'
import concludeApplication from "./v3/concludeApplication";
import getDistrict from "./payment/getDistrict"
import pagingApplicationNurse from "./nurse/pagingApplicationNurse";
import addNoteToApplication from "./nurse/addNoteToApplication";
import applicationNoteFullHistory from "./nurse/applicationNoteFullHistory";
import editCareProvider from "./nurse/editCareProvider";
import completeNurseAssesment from "./nurse/completeNurseAssesment";
import applicationNotePatient from "./application/applicationNotePatient";
import applicationPatientChatRight from "./application/applicationPatientChatRight";
import cartUpdate from "./payment/cartUpdate";
import targetInstitutionDetail from "./application/targetInstitutionDetail";
import saveApplicationResult from "./application/saveApplicationResult";
import lastApplicationResult from "./application/lastApplicationResult";
import suggestions from "./suggestions";
import deleteApplication from "./application/deleteApplication";
import { verifyTfa } from "../actions/auth/login";
export default combineReducers({
  checkout,
  deleteBasket,
  getAddresses,
  getBasket,
  getCitiesByDistrictName,
  getCountries,
  genesis,
  login,
  forgotPassword,
  forgotPasswordVerify,
  verifyCode,
  register,
  patientRegister,
  professions,
  setSurvey,
  startApplication,
  careProviders,
  assignApplication,
  payment,
  getApplications,
  getApplication,
  getDoctorCv,
  addAddress,
  addBasket,
  removeAddress,
  updateApplicationStatus,
  trigerApplicationStatus,
  getOtp,
  approveOtp,
  getMSS,
  signMSS,
  deleteAttachment,
  professionsv2,
  careProvidersv2,
  startApplicationv2,
  attachFile,
  dettachFile,
  pagingApplication,
  pagingApplicationsCareProvider,
  addNote,
  notifyPayment,
  applicationDetail,
  assessApplication,
  concludeApplication,
  getDistrict,
  pagingApplicationNurse,
  addNoteToApplication,
  applicationNoteFullHistory,
  editCareProvider,
  completeNurseAssesment,
  applicationNotePatient,
  applicationPatientChatRight,
  cartUpdate,
  targetInstitutionDetail,
  saveApplicationResult,
  lastApplicationResult,
  suggestions,
  deleteApplication,
  verifyTfa
});